import React from "react";
import { InterpretedText } from "components/atoms/interpretedText";

import quoteLeftSrc from "../../../../assets/images/icon_quote_left.svg";
import quoteRightSrc from "../../../../assets/images/icon_quote_right.svg";
import styles from "./index.module.scss";

interface Props {
  source?: string | null;
  text: string;
}

class BlockQuote extends React.PureComponent<Props> {
  public render() {
    const { source, text } = this.props;

    return (
      <div className={styles.container}>
        <div className={styles.background}>
          <img className={styles.quoteStart} src={quoteLeftSrc} alt="" />
          <div className={styles.contentContainer}>
            <div className={styles.text}>
              <InterpretedText text={text} />
            </div>
            {!source ? null : <div className={styles.source}>－ {source}</div>}
          </div>
          <img className={styles.quoteEnd} src={quoteRightSrc} alt="" />
        </div>
      </div>
    );
  }
}

export { BlockQuote };
